import { render, staticRenderFns } from "./kioskConfig.vue?vue&type=template&id=ee68c098"
import script from "./kioskConfig.vue?vue&type=script&lang=js"
export * from "./kioskConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports